<template>
  <v-content>
    <v-container fluid>
      <Header :title="title" />
      <v-row no-gutters>
        <v-col cols="12">
          <DataTable
            @editing="editing"
            @deleting="deleting"
            :title="''"
            :actiontitle="'Equipment Template'"
            :headers="headers"
            :items="equipmenttemplatedata"
            :search="search"
          />
        </v-col>
        <Dialogbox
          @closing="closing"
          @deleteuser="deleteCalibrationTemplate"
          :title="dialogboxtitle"
          :dialog="dialogstatus"
          :buttonTitle="dialogButtontitle"
          :deleteuser="true"
          v-if="dialogstatus"
        />
      </v-row>
    </v-container>
    <v-btn dark fab fixed bottom right large color="pink" class="mx-2"  v-if="canAdd" @click="addCalibrationTemplate">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-content>
</template>

<script>
import { mapGetters } from "vuex"
import store from "@/store"
import {
  FETCH_EQUIPMENT_TEMPLATE_DATA,
  DELETE_EQUIPMENT_TEMPLATE_DATA,
  RESET_STATE
} from "@/store/actions.type";
import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
export default {
  name: "EquipmentGroups",
  beforeRouteEnter(to, from, next) {
    store.dispatch(RESET_STATE)
    store.dispatch(FETCH_EQUIPMENT_TEMPLATE_DATA, "").then(resp => {
      if (resp.success) {
        store.commit(SET_LOADING, false)
        store.commit(SET_ROUTER_ENTER, false)
      }
    });
    return next();
  },
  beforeRouteLeave(to, from, next) {
    store.dispatch(RESET_STATE)
    next();
  },
  data: function() {
    return {
      title: "Equipment Template",
      search: "",
      dialogstatus: false,
      dialogButtontitle: null,
      dialogboxtitle: null,
      callirationtemplateid: null,
      singleSelect: "",
      dialog: false,
    };
  },
  components: {
    DataTable: () => import("@/components/datatable/datatable"),
    Dialogbox: () => import("@/components/dialog/dialog"),
    Header: () => import("@/components/header/Header")
  },
  computed: {
    ...mapGetters(["equipmenttemplatedata",'currentUser']),
    headers () {
      return [
        { text: this.$t("Equipment template id"), value: "temp_id" },  
        { text: this.$t("Name"), value: "temp_name" },  
        { text: this.$t("Validity"), value: "temp_validity" },      
        { text: this.$t("Actions"), value: "action", sortable: false }
      ]
    },
    canAdd(){
      if(typeof (this.currentUser) !== 'undefined') {
        if(this.currentUser.roles.includes(1) || this.currentUser.permissions.includes('can-create-equipment-template')){
          return true;
        }
      }
      return false;
    },
  },
  created (){
    if(!this.hasrequiredPermissions()){
      this.$router.push('/dashboard');
    }
  },
  methods: {
    hasrequiredPermissions(){
      if(this.currentUser.roles.includes(1) == true || this.currentUser.permissions.includes('can-create-equipment-template') || this.currentUser.permissions.includes('can-update-equipment-template') || this.currentUser.permissions.includes('can-delete-equipment-template') ){
        return true;
      }
      return false;
    },
    addCalibrationTemplate() {
      this.$router.push("/equipment-template/add");
    },
    editing(id) {
      this.$router.push("/equipment-template/edit/" + id)
    },
    deleting(id) {
      this.dialogstatus = true
      this.dialogboxtitle = "Are you sure want to remove?"
      this.dialogButtontitle = "Remove"
      this.callirationtemplateid = id
    },
    async deleteCalibrationTemplate() {
      await this.$store
        .dispatch(DELETE_EQUIPMENT_TEMPLATE_DATA, this.callirationtemplateid)
        .then(async resp => {
          if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
            this.callirationtemplateid = null;
            await store.dispatch(FETCH_EQUIPMENT_TEMPLATE_DATA, "").then(resp => {
              if (resp.success) {
                store.commit(SET_LOADING, false);
                this.dialogstatus = false;
              }
            });
          }
          else{
            store.commit(SET_LOADING, false);
          }
        });
    },
    closing() {
      this.dialogstatus = false
    },
  }
};
</script>